import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/erroricon.svg'


const _hoisted_1 = { class: "errcontainerdiv" }
const _hoisted_2 = { class: "errorinnerdiv" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "errortextdiv" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "imagestyle",
    alt: "erroriconimg",
    title: "erroriconimg"
  }),
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("b", null, " Sorry, page not found (404). ")
  ])
], -1)
const _hoisted_4 = { class: "normalerrortext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("text", null, [
          _createTextVNode(" Please click "),
          _createVNode(_component_el_link, {
            href: "/account",
            target: "_self",
            type: "warning",
            id: "homelink",
            class: "normalerrortext"
          }, {
            default: _withCtx(() => [
              _createTextVNode("here")
            ]),
            _: 1
          }),
          _createTextVNode(" to go to overview page. ")
        ])
      ])
    ])
  ]))
}